export default {
  validateInputLength,
  validatePhoneInput,
  getUpdateFormError,
  getGoalCreationErrors,
  convertFieldErrors,
  fieldHasError,
  getFieldErrorDetail,
}

export const validateInputLength = (fieldName, input) => {
  if (!input) {
    return {
      field: fieldName,
      detail: 'This field is required.',
    }
  } else {
    return null
  }
}

export const validatePhoneInput = (fieldName, input) => {
  if (!input) {
    return null
  }

  const parsedPhone = input.replace(/(\(|\)| |-)/g, '')
  return !parsedPhone || parsedPhone.match(/^\+[0-9]{9,15}$/i)
    ? null
    : { field: fieldName, detail: 'Phone number is invalid.' }
}

export const validateSelectMinimum = (fieldName, arr) => {
  if (arr.length < 1) {
    return {
      field: fieldName,
      detail: 'Please select at least one.',
    }
  } else {
    return null
  }
}

function getUpdateFormError(updateData) {
  const errors = []

  if (!updateData.title) {
    errors.push({
      field: 'title',
      detail: 'This field is required',
    })
  }

  if (!updateData.text) {
    errors.push({
      field: 'description',
      detail: 'This field is required',
    })
  }

  return errors
}

function getGoalCreationErrors(goalData) {
  const errors = []

  if (!goalData.targetFunds) {
    errors.push({
      field: 'target-funds',
      detail: 'This field is required',
    })
  }

  if (!goalData.title) {
    errors.push({
      field: 'title',
      detail: 'This field is required',
    })
  }

  if (!goalData.description) {
    errors.push({
      field: 'description',
      detail: 'This field is required',
    })
  }

  if (!goalData.endDate) {
    errors.push({
      field: 'end-date',
      detail: 'This field is required',
    })
  }

  return errors
}

function convertFieldErrors(errors) {
  // function to convert field errors into the same format as client errors
  const newErrorsArray = []
  Object.keys(errors).forEach(errorKey => {
    let newError = { field: '', detail: '' }
    newError.field = errorKey
    newError.detail = errors[errorKey][0]
    newErrorsArray.push(newError)
  })
  return newErrorsArray
}

function fieldHasError(fieldName, errors) {
  return () => errors.filter(error => error.field === fieldName).length > 0
}

function getFieldErrorDetail(fieldName, errors) {
  const error = errors.filter(e => e.field === fieldName)[0]
  if (error) {
    return error.detail
  }
  return ''
}
